import { jsx as _jsx } from "react/jsx-runtime";
import {} from 'react';
import { cn } from '../lib/cn.js';
/**
 * Interp — the INTERP pill that tags AI interpretation distinct from
 * grounded fact. Required pairing for any synthesized claim that
 * extrapolates beyond the cited evidence (e.g. "this likely means X").
 *
 * Visual = small uppercase mono pill in steel, set inline next to the
 * claim. The tooltip-style note on hover comes from the consuming
 * component; this primitive is just the marker.
 *
 * Per CLAUDE.md ground rule: AI-synthesized facts wrapped in
 * `<SourceBadge>` + `<ConfidenceMeter>`; INTERP tags distinguish
 * interpretation from grounded fact.
 */
export function Interp({ children = 'INTERP', className, title, }) {
    return (_jsx("span", { title: title, className: cn('inline-flex items-center rounded-[var(--r-1,4px)] border border-[var(--color-steel)] bg-[var(--color-steel-soft)] px-1.5 py-0.5 font-mono text-[10px] uppercase tracking-[0.08em] text-[var(--color-steel)]', className), children: children }));
}
